import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/@mui/icons-material/AutoAwesome.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/@mui/icons-material/SendRounded.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/cartao-de-credito/[slug]/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ButtonBackToTop/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CardGrid/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/GuideUtua/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/InfoCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/img/loading.svg");
